import { apiClient } from '../../../../api/axios';
import type { ApiResponse } from '../common/types';
import type { UserNotification } from './types';

export const notificationService = {
    getUserNotifications: async (forNotificationBar: boolean): Promise<ApiResponse<UserNotification[]>> => {
        const response = await apiClient.get(
            `/Notifications/GetUserNotification?forNotificationBar=${forNotificationBar}`
        );
        return response.data;
    },

    markMessageAsRead: async (messageId: number): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(
            `/Notifications/UpdateReadMessage?messageId=${messageId}`
        );
        return response.data;
    },

    sendEmailMessages: async (payload: FormData): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post('/Notifications/SendEmailMessages', payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },
};
